export type TimingStyle = {
  bg: string;
  text: string;
  label: string;
};

export function timingScoreStyle(pct: number): TimingStyle {
  if (pct >= 75) return { bg: "bg-emerald-500", text: "text-white", label: "Sweet spot" };
  if (pct >= 58) return { bg: "bg-lime-500", text: "text-white", label: "Great" };
  if (pct >= 42) return { bg: "bg-amber-400", text: "text-navy", label: "Average" };
  if (pct >= 28) return { bg: "bg-orange-400", text: "text-white", label: "Below average" };
  return { bg: "bg-red-400", text: "text-white", label: "Peak season" };
}

export function timingBarColour(avgRaw: number, weekCount: number): string {
  if (weekCount === 0) return "bg-border-light";
  const pct = Math.round(avgRaw * 100);
  return timingScoreStyle(pct).bg;
}

export const TIMING_BANDS: { minPct: number; label: string; bg: string }[] = [
  { minPct: 75, label: "Sweet spot", bg: "bg-emerald-500" },
  { minPct: 58, label: "Great", bg: "bg-lime-500" },
  { minPct: 42, label: "Average", bg: "bg-amber-400" },
  { minPct: 28, label: "Below average", bg: "bg-orange-400" },
  { minPct: 0, label: "Peak season", bg: "bg-red-400" },
];
